export default function getVariantCount(variants) {
  if (variants === undefined) return null
  if (variants.length === 0) return null
  if (variants.length === 1) return '1 variant'
  return variants.length + ' variants'
}
